export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4753.f1d7b5e1.jpg";